import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import Box from '@material-ui/core/Box';
import blue from '@material-ui/core/colors/blue';
import Card from '@material-ui/core/Card';

import Store from 'store';

class DateCell extends Component {

  groupKey = ""
  onClick
  todos = []

  constructor(props) {
    super(props);
    this.day = props.day
    this.groupKey = "todos_" + this.day.desc + "_" + this.day.week + "_" + this.day.year
    this.onClick = props.onClick

    this.todos = Store.get(this.groupKey);
    if (this.todos === undefined) {
      Store.set(this.groupKey, [])
      this.todos = []
    }
  }

  onClickInternal = () => {
    this.onClick(this.day, this.day.desc + "_" + this.day.week + "_" + this.day.year)
  }

  render() {

    var todoListItems = [];
    for (var i = 0; i < this.todos.length; i++) {
      var item = this.todos[i];
      todoListItems.push(
        <Grid item xs={12} style={{"text-align":"left"}}>
          {item.name}
        </Grid>);
    }

    return (
      <Grid item xs>
        <ButtonBase focusRipple style={{minHeight:"150px", width:"100%"}} onClick={this.onClickInternal}>
          <Grid component={Card} container style={{"margin":"5px", "padding-left":"5px", "padding-right":"5px", "background-color":blue[200]}}>
            <Grid item xs={12}>
              <Box textAlign="right">
                <Typography>{this.day.desc}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} style={{"height":"130px"}}>
              <Grid container>
                {todoListItems}
              </Grid>
            </Grid>
          </Grid>
        </ButtonBase>
      </Grid>
    );
  }
}

export default DateCell;



// WEBPACK FOOTER //
// ./src/comps/DateCell.js